import axios from "axios";
import licenses from "../../models/cargaDeLicencias/licenses";
import detail from "../../models/cargaDeLicencias/details";
import moment from "moment";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getLicenses(payload) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    // Configuración inicial del request con los headers
    let config = { headers };

    // Si no se proporciona payload o está vacío, agregamos parámetros de orden por defecto
    if (!payload || Object.keys(payload).length === 0) {
      config.params = { filter: { order: "procId desc" } };
    } else {
      // Si se proporciona un payload, lo usamos como query params (filter)
      config.params = { filter: payload };
    }

    // Realizamos la solicitud GET
    return axios.get(`${url}/proclicencias`, config).then(({ data }) => {
      return data.map((item) => licenses.fromJson(item));
    });
  }

  getLicenseDetail(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/proclicencias/details/${id}`, { headers })
      .then(({ data }) => {
        let details = data.map((item) => detail.fromJson(item));
        details.sort((a, b) => a.stFormato - b.stFormato);
        return details;
      });
  }

  new(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload;
    payload = {
      nombre: data.nombre,
      operId: Number(localStorage.getItem("operId")),
      detalles: data.detalles,
    };

    return axios.post(`${url}/proclicencias`, payload, { headers });
  }
  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    // Inicializamos el payload solo con 'nombre'
    let payload = {
      nombre: data.nombre,
    };

    // Solo incluimos 'estado' si no es undefined
    if (data.estado !== undefined) {
      payload.estado = data.estado === true ? "T" : "I";
    }

    return axios.patch(`${url}/proclicencias/${data.procId}`, payload, {
      headers,
    });
  }

  delete = (id) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.delete(`${url}/proclicencias/${id}`, { headers });
  };

  editDetail(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let payload;

    payload = {
      legajo: data.legajo,
      empId: data.empId == null ? undefined : data.empId,
      ent: data.ent
        ? moment(data.ent, "YYYY-MM-DD HH:mm").utc().format()
        : undefined,
      sal: data.sal
        ? moment(data.sal, "YYYY-MM-DD HH:mm").utc().format()
        : undefined,
      concepto: data.concepto,
      conceptoId: data.conceptoId,
      observaciones: data.observaciones,
    };

    return axios.patch(
      `${url}/proclicencias/details/${data.procId}&${data.liId}

    `,
      payload,
      { headers }
    );
  }

  deleteDetail = (data) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(
      `${url}/proclicencias/details/${data.procId}&${data.liId}`,
      { headers }
    );
  };

  process(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.patch(
      `${url}/proclicencias/procesar/${data.procId}

    `,
      undefined,
      { headers }
    );
  }
}
export default service;
